__turbopack_context__.v({
  "disabled": "submitButton-module-scss-module__RS6DNW__disabled",
  "dots": "submitButton-module-scss-module__RS6DNW__dots",
  "submitButton": "submitButton-module-scss-module__RS6DNW__submitButton",
});
